const DAUM_POSTCODE_SRC = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';

export function loadDaumPostcode() {
  return new Promise((resolve, reject) => {
    if (window.daum?.Postcode) {
      resolve(window.daum.Postcode);
      return;
    }

    const existing = document.querySelector('script[data-daum-postcode="true"]');
    if (existing) {
      const onLoad = () => resolve(window.daum.Postcode);
      const onError = () => reject(new Error('주소 검색 스크립트를 불러오지 못했습니다.'));
      existing.addEventListener('load', onLoad, { once: true });
      existing.addEventListener('error', onError, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = DAUM_POSTCODE_SRC;
    script.async = true;
    script.dataset.daumPostcode = 'true';
    script.onload = () => resolve(window.daum.Postcode);
    script.onerror = () => reject(new Error('주소 검색 스크립트를 불러오지 못했습니다.'));
    document.head.appendChild(script);
  });
}

/** 다음 우편번호 선택 결과를 정규화된 주소 객체로 변환 */
export function normalizeDaumAddress(data) {
  if (!data) return { zonecode: '', address: '', detailHint: '' };

  const isRoad = data.userSelectedType === 'R';
  const base = isRoad ? (data.roadAddress || data.address || '') : (data.jibunAddress || data.address || '');

  let extra = '';
  if (isRoad) {
    if (data.bname && /[동로가]$/.test(data.bname)) {
      extra += data.bname;
    }
    if (data.buildingName && data.apartment === 'Y') {
      extra += (extra ? `, ${data.buildingName}` : data.buildingName);
    }
    if (extra) extra = ` (${extra})`;
  }

  return {
    zonecode: String(data.zonecode || ''),
    address: `${base}${extra}`.trim(),
    detailHint: '',
  };
}
